export const USERS_TYPES = {
  Personal: "personal",
  Corporate: "corporate",
  Maker: "maker",
  Approval: "approval",
};
